import React from 'react'

function Locate({ colorCode, classLocate, onClickLocate }) {
    return (
        <svg className={`MuiSvgIcon-root pointer ${classLocate}`} viewBox="0 0 24 29" style={{ fill: 'none' }} onClick={onClickLocate}>
            <path d="M22.751 12.0096C22.751 20.4684 11.8755 27.7187 11.8755 27.7187C11.8755 27.7187 1 20.4684 1 12.0096C1 9.12528 2.14581 6.35906 4.18536 4.31951C6.22491 2.27996 8.99113 1.13416 11.8755 1.13416C14.7598 1.13416 17.5261 2.27996 19.5656 4.31951C21.6052 6.35906 22.751 9.12528 22.751 12.0096Z" stroke={colorCode} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.8757 15.6348C13.8778 15.6348 15.5008 14.0117 15.5008 12.0096C15.5008 10.0075 13.8778 8.38446 11.8757 8.38446C9.87353 8.38446 8.25049 10.0075 8.25049 12.0096C8.25049 14.0117 9.87353 15.6348 11.8757 15.6348Z" stroke={colorCode} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default Locate
